<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.attribution_license }}</div>
        </div>
        <div class="overflow-y-auto h-screen attribution-license-content-height" v-if="mapData.attribution_license">
            <div class="mx-4">
            <div
                class="p-3 rounded bg-base-200 font-mono text_overflow mb-52 text-left"
                style="word-break: break-all; white-space: pre-wrap;"
            >
                <span v-readMore:200="mapData.attribution_license"></span>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import ReadMoreDirective from '../custom_directives/ReadMore';

export default {
    inject: ['trans'],
    directives: {
        'readMore' : ReadMoreDirective
    },
    props: {
        mapData: {
            type: Object,
            required: true
        },
    },
};
</script>